import { AddCircle, RemoveCircle } from '@mui/icons-material'
import {
  Container,
  Grid,
  Paper,
  Table, TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'
import { useState } from 'react'
import { type ExperienceUpdate } from '../../../api'
import ExperienceAppendDialog from './ExperienceAppendDialog'
import ListRemoveDialog from './ListRemoveDialog'
import { type UserInfoUpdateAction } from './userInfoReducer'

function ExperienceListEdit ({
  experienceUpdateList,
  dispatch
}: {
  experienceUpdateList: ExperienceUpdate[]
  dispatch: React.Dispatch<UserInfoUpdateAction>
}): JSX.Element {
  const [removeDialogOpen, setRemoveDialogOpen] = useState(false)
  const [addDialogOpen, setAddDialogOpen] = useState(false)
  const [removeIdx, setRemoveIdx] = useState<number | null>(null)

  const handleRemove = (): void => {
    if (removeIdx !== null) {
      dispatch({
        type: 'list-remove',
        key: 'experienceUpdateList',
        data: experienceUpdateList[removeIdx],
        idx: removeIdx
      })
      setRemoveIdx(null)
    }
    setRemoveDialogOpen(false)
  }

  const cancelRemove = (): void => {
    setRemoveIdx(null)
    setRemoveDialogOpen(false)
  }

  const handleAppend = (item: ExperienceUpdate): void => {
    dispatch({
      type: 'list-append',
      key: 'experienceUpdateList',
      data: item
    })
    setAddDialogOpen(false)
  }

  const cancelAppend = (): void => {
    setAddDialogOpen(false)
  }

  return (
    <Paper sx={{ flexGrow: 1, p: 0.5, m: 0.5 }}>
      <ListRemoveDialog
        open={removeDialogOpen}
        onConfirm={handleRemove}
        onCancel={cancelRemove}
      />
      <ExperienceAppendDialog
        open={addDialogOpen}
        onConfirm={handleAppend}
        onCancel={cancelAppend}
      />
      {/* contactList */}
      <Grid container columns={12}>
        <Grid item xs={12}>
          <Typography variant='h6' p={0.5} m={0.5}>
            경력
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>기간</TableCell>
                  <TableCell align="center">기관</TableCell>
                  <TableCell align="center">내용</TableCell>
                  <TableCell/>
                </TableRow>
              </TableHead>
              <TableBody>
                {experienceUpdateList.map((experienceUpdate, i) => (
                  <TableRow key={i}>
                    <TableCell>{
                        experienceUpdate.startYear ?? ''
                      } - {
                        experienceUpdate.endYear ?? ''
                    }</TableCell>
                    <TableCell align="center">
                      {experienceUpdate.company}
                    </TableCell>
                    <TableCell align="center">
                      {experienceUpdate.content}
                    </TableCell>
                    <TableCell align="center">
                      <RemoveCircle
                        sx={{ color: '#FFA500' }}
                        onClick={() => {
                          setRemoveIdx(i)
                          setRemoveDialogOpen(true)
                        }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Grid item xs={12}>
            <Container sx={{ display: 'flex', justifyContent: 'center', m: 1 }}>
              <AddCircle sx={{ color: '#FFA500' }} onClick={() => {
                setAddDialogOpen(true)
              }}/>
            </Container>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default ExperienceListEdit
